<template lang="pug">
    .animations(ref='animation')
        .barbel
            svg(height='116' viewBox='0 0 226 116' fill='none' xmlns='http://www.w3.org/2000/svg')
                g#barbel
                    path.disc_right(d='M175.474 115.457H188.923V0.74749H175.474V115.457Z' fill='#FF0000' transform='translate(120, 0)' ref='pathLeft1')
                    path.disc_right(d='M193.994 101.83H207.443V14.3391H193.994V101.83Z' fill='#FF0000' transform='translate(120, 0)' ref='pathLeft2')
                    path.disc_right(d='M212.551 86.1387H226V30.0292H212.551V86.1387Z' fill='#FF0000' transform='translate(120, 0)' ref='pathLeft3')


                    path.disc_left(d='M50.5586 0.736328H37.1094V115.446H50.5586V0.736328Z' fill='#FF0000' transform='translate(-120, 0)' ref='pathRight1')
                    path.disc_left(d='M31.9873 14.3638H18.5381V101.855H31.9873V14.3638Z' fill='#FF0000' transform='translate(-120, 0)' ref='pathRight2')
                    path.disc_left(d='M13.4492 30.0537H0V86.1632H13.4492V30.0537Z' fill='#FF0000' transform='translate(-120, 0)' ref='pathRight3')

                    path(d='M170.36 64.8237V51.3745L55.6508 51.3745V64.8237L170.36 64.8237Z' fill='#FF0000')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';
export default {
    mixins: [mixinAnimation],
    props: {
        isActive: Boolean
    },
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        },
        createTimeline() {
            let discsLeft = this.$refs.animation.querySelectorAll('.disc_left');
            let discsRight = this.$refs.animation.querySelectorAll('.disc_right');
            this.timeline = gsap.timeline();
            this.timeline
                .fromTo(discsLeft, {x: -120}, {duration: 3, x: 0, ease: 'power2.inOut', stagger: {each: 1}}, 0)
                .fromTo(discsRight, {x: 120}, {duration: 3, x: 0, ease: 'power2.inOut', stagger: {each: 1}}, 0);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.barbel {
    padding-left: var(--grid-column);
    position: relative;
    width: 100%;
    svg {
        width: 100%;
        @media (--viewport-tablet) {
            width: 226px;
            display: block;
            margin: 0 auto;
        }
    }
    @media (--viewport-tablet) {
        padding: 0;
    }

    &__use {
        x: calc(var(--grid-column) + 8);
        @media (--viewport-tablet) {
            x: 0;
        }
    }
}
</style>
